<template>
  <div class="my-info-container">
    <div class="my-info-header">
      <h2>我的信息</h2>
      <p>管理您的个人信息和账户设置</p>
    </div>

    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!-- 个人中心 -->
      <el-tab-pane label="个人中心" name="个人中心">
        <span slot="label"><i class="el-icon-user-solid"></i> 个人中心</span>
        <el-form label-position="left" :model="userInfo" label-width="100px" :rules="rules" ref="userInfo">
          <el-form-item label="头像" :label-width="labelWidth">
            <div class="imgBody" v-if="userInfo.photoUrl">
              <i class="el-icon-error inputClass" v-show="icon" @click="deletePhoto('user')"
                @mouseover="icon = true"></i>
              <img @mouseover="icon = true" @mouseout="icon = false" v-bind:src="userInfo.photoUrl" />
            </div>

            <div v-else class="uploadImgBody" @click="checkPhoto">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-form-item>

          <el-form-item label="昵称" :label-width="labelWidth" prop="nickName">
            <el-input v-model="userInfo.nickName" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="性别" :label-width="labelWidth">
            <el-radio v-for="gender in genderDictList" :key="gender.uid" v-model="userInfo.gender"
              :label="gender.dictValue" border size="medium">{{ gender.dictLabel }}
            </el-radio>
          </el-form-item>

          <el-form-item label="钱包" :label-width="labelWidth" prop="occupation">
            <span style="font-weight: bold">{{ fenToYuan(userAmount) }}</span><span> 元</span>
            <el-button v-if="userAmount > 0" style="margin-left: 10px" type="warning" size="mini"
              @click="withdrawAmount">提现
            </el-button>
          </el-form-item>

          <el-form-item label="邮件通知" :label-width="labelWidth">
            <el-radio v-for="item in yesNoDictList" :key="item.uid" v-model="userInfo.startEmailNotification"
              :label="parseInt(item.dictValue)" border size="medium">{{ item.dictLabel }}
            </el-radio>
          </el-form-item>

          <!-- <el-form-item label="编辑器" :label-width="labelWidth">
            <el-radio v-for="item in editorModalDictList" :key="item.uid" v-model="userInfo.editorModel"
              :label="item.dictValue" border size="medium">{{ item.dictLabel }}
            </el-radio>
          </el-form-item> -->

          <el-form-item label="邮箱" :label-width="labelWidth" prop="email">
            <el-input v-model="userInfo.email" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="职业" :label-width="labelWidth" prop="occupation">
            <el-input v-model="userInfo.occupation" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="简介" :label-width="labelWidth" prop="summary">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入内容" style="width: 100%"
              v-model="userInfo.summary">
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('editUser')">保 存
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 修改密码 -->
      <el-tab-pane label="修改密码" name="修改密码">
        <span slot="label"><i class="el-icon-s-tools"></i> 修改密码</span>
        <el-collapse v-model="activeNames">
          <el-collapse-item title="修改密码须知" name="1">
            <div>此修改密码功能仅适用于账号和密码登录</div>
            <div>对于第三方登录的账号，无法进行密码修改</div>
          </el-collapse-item>
        </el-collapse>
        <el-form ref="userInfoForm" label-position="left" :model="userInfo" label-width="100px"
          :rules="userInfoRules">
          <el-form-item label="旧密码" :label-width="labelWidth" prop="oldPwd">
            <el-input type="password" v-model="userInfo.oldPwd" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="新密码" :label-width="labelWidth" prop="newPwd">
            <el-input type="password" v-model="userInfo.newPwd" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item label="重复密码" :label-width="labelWidth" prop="newPwd2">
            <el-input type="password" v-model="userInfo.newPwd2" style="width: 100%"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('changePwd')">提 交
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 账号绑定 
      <el-tab-pane label="账号绑定" name="账号绑定">
        <span slot="label"><i class="el-icon-s-flag"></i> 账号绑定</span>
        <div style="width: 100%; overflow: auto">
          <el-table :data="accountList" style="width: 100%">
            <el-table-column label="序号" width="50" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="渠道" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.sourceDesc }}</span>
              </template>
            </el-table-column>

            <el-table-column label="用户" width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.nickName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="绑定时间" width="160" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.bindTime }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div style="margin-top: 5px; margin-bottom: 5px">
            你还可以绑定以下第三方帐号进行登录
          </div>
          <el-tooltip content="码云" placement="bottom" v-if="!loginType.gitee">
            <el-button type="danger" circle @click="goBind('gitee')" :disabled="loginType.gitee">
              <span class="iconfont">&#xe602;</span>
            </el-button>
          </el-tooltip>

          <el-tooltip content="Github" placement="bottom" v-if="!loginType.github">
            <el-button type="info" circle @click="goBind('github')" :disabled="loginType.github">
              <span class="iconfont">&#xe64a;</span>
            </el-button>
          </el-tooltip>

          <el-tooltip content="QQ" placement="bottom" v-if="!loginType.qq">
            <el-button type="primary" circle @click="goBind('qq')" :disabled="loginType.qq">
              <span class="iconfont">&#xe601;</span>
            </el-button>
          </el-tooltip>

          <el-tooltip content="微信公众号" placement="bottom" v-if="!loginType.wechat">
            <el-button type="success" circle @click="goBind('wechat')" :disabled="loginType.wechat">
              <span class="iconfont">&#xe60b;</span>
            </el-button>
          </el-tooltip>

          <el-tooltip content="微信小程序" placement="bottom" v-if="!loginType.mini">
            <el-button type="success" circle @click="goBind('mini')" :disabled="loginType.mini">
              <span class="iconfont">&#xe668;</span>
            </el-button>
          </el-tooltip>

          <el-tooltip content="微信" placement="bottom" v-if="!loginType.personWechat">
            <el-button type="success" circle @click="goBind('person_wechat')" :disabled="loginType.personWechat">
              <span class="iconfont">&#xe66f;</span>
            </el-button>
          </el-tooltip>
        </div>
      </el-tab-pane>-->
    </el-tabs>

    <!--头像裁剪-->
    <avatar-cropper v-show="imagecropperShow" :key="imagecropperKey" :width="300" :height="300" :url="url"
      lang-type="zh" @close="close" @crop-upload-success="cropSuccess" />

    <!--提现操作-->
    <el-dialog title="请填写提现信息" :visible.sync="drawDialogVisible" width="30%" center>
      <div style="text-align: center">
        <el-form :rules="withdrawRules" :model="withdrawForm" ref="withdrawForm">
          <el-form-item label="微信账号" :label-width="lineLabelWidth" prop="account">
            <el-input v-model="withdrawForm.account" maxlength="50" placeholder="请输入微信账号" clearable></el-input>
          </el-form-item>

          <el-form-item label="收款码" :label-width="lineLabelWidth" prop="fileUid">
            <div class="imgBody" v-if="withdrawForm.photoUrl">
              <i class="el-icon-error inputClass" v-show="icon" @click="deletePhoto('withdraw')"
                @mouseover="icon = true"></i>
              <img @mouseover="icon = true" @mouseout="icon = false" v-bind:src="withdrawForm.photoUrl" />
            </div>

            <div v-else class="uploadImgBody" @click="checkPhoto">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-form-item>

          <el-form-item label="提现金额(元)" :label-width="lineLabelWidth" prop="amount">
            <el-input-number v-model="withdrawForm.amount" :precision="2" :step="0.01" :min="0"
              :max="fenToYuanNumber(userAmount)" style="float: left"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="drawDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitWithdraw">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AvatarCropper from "@/components/AvatarCropper";
import { 
  editUser, 
  updateUserPwd, 
  getAccountBindList,
  authVerify
} from "@/api/user";
import { 
  addWithdraw 
} from "@/api/pay";
import { getCurrentUserAmount } from "@/api/about";
import { getListByDictTypeList } from "@/api/sysDictData";
import { getCookie } from "@/utils/cookieUtils";

export default {
  name: "MyInfo",
  components: {
    AvatarCropper
  },
  data() {
    return {
      activeName: "个人中心",
      activeNames: ["1"],
      labelWidth: "120px",
      lineLabelWidth: "120px",
      icon: false,
      imagecropperShow: false,
      imagecropperKey: 0,
      url: process.env.PICTURE_API + "/file/cropperPicture",
      drawDialogVisible: false,
      userInfo: {
        photoUrl: "",
        nickName: "",
        gender: "",
        startEmailNotification: 0,
        editorModel: "",
        email: "",
        occupation: "",
        summary: "",
        oldPwd: "",
        newPwd: "",
        newPwd2: ""
      },
      userAmount: 0,
      accountList: [],
      withdrawForm: {
        account: "",
        photoUrl: "",
        fileUid: "",
        amount: 0
      },
      loginType: {
        gitee: false,
        github: false,
        qq: false,
        wechat: false,
        mini: false,
        personWechat: false
      },
      genderDictList: [],
      yesNoDictList: [],
      editorModalDictList: [],
      rules: {
        nickName: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: ["blur", "change"] }
        ]
      },
      userInfoRules: {
        oldPwd: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" }
        ],
        newPwd2: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: this.validatePwd2, trigger: "blur" }
        ]
      },
      withdrawRules: {
        account: [
          { required: true, message: "请输入微信账号", trigger: "blur" }
        ],
        fileUid: [
          { required: true, message: "请上传收款码", trigger: "blur" }
        ],
        amount: [
          { required: true, message: "请输入提现金额", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.initData();
  },
  activated() {
    // 当组件被激活时重新获取数据（适用于keep-alive场景）
    this.initData(true);
  },
  watch: {
    // 监听store中用户信息的变化
    '$store.state.user.userInfo': {
      handler(newUserInfo) {
        if (newUserInfo && Object.keys(newUserInfo).length > 0) {
          this.userInfo = Object.assign({}, newUserInfo);
          this.getUserAmount();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async initData(forceRefresh = false) {
      try {
        // 先获取字典数据
        await this.getDictList();
        
        // 如果强制刷新或store中没有用户数据，则获取用户信息
        let userInfo = this.$store.state.user.userInfo;
        if (forceRefresh || !userInfo || Object.keys(userInfo).length === 0) {
          this.authVerifyUser();
        } else {
          this.getUserInfo();
        }
        
        // 最后获取账号绑定信息
        this.getBindAccount();
      } catch (error) {
        console.error("初始化数据失败:", error);
      }
    },
    getUserInfo() {
      // 从store获取用户信息
      let userInfo = this.$store.state.user.userInfo;
      if (userInfo && Object.keys(userInfo).length > 0) {
        this.userInfo = Object.assign({}, userInfo);
        // 获取用户余额
        this.getUserAmount();
      } else {
        // 如果store中没有用户信息，尝试通过token验证获取
        this.authVerifyUser();
      }
    },
    // 验证用户并获取用户信息
    authVerifyUser() {
      let token = getCookie("token");
      if (token) {
        authVerify(token).then((response) => {
          if (response && response.code == this.$ECode.SUCCESS) {
            // 确保获取到完整的用户信息
            this.userInfo = Object.assign({}, response.data);
            // 更新store中的用户信息
            this.$store.commit('user/setUserInfo', response.data);
            // 重新获取用户余额
            this.getUserAmount();
          } else {
            // 如果验证失败，可能需要重新登录
            console.warn("用户验证失败，请重新登录");
          }
        }).catch((error) => {
          console.error("获取用户信息失败:", error);
        });
      } else {
        console.warn("未找到登录token");
      }
    },
    // 强制刷新用户信息
    forceRefreshUserInfo() {
      this.authVerifyUser();
    },
    // 获取用户余额
    getUserAmount() {
      getCurrentUserAmount().then((response) => {
        if (response.code == this.$ECode.SUCCESS) {
          this.userAmount = response.data || 0;
        }
      }).catch((error) => {
        console.log("获取用户余额失败:", error);
      });
    },
    getDictList() {
      return new Promise((resolve, reject) => {
        let dictTypeList = [
          "sys_yes_no",
          "sys_user_sex", 
          "sys_editor_modal"
        ];
        getListByDictTypeList(dictTypeList).then((response) => {
          if (response.code == this.$ECode.SUCCESS) {
            let dictMap = response.data;
            this.genderDictList = dictMap.sys_user_sex.list;
            this.yesNoDictList = dictMap.sys_yes_no.list;
            this.editorModalDictList = dictMap.sys_editor_modal.list;
            resolve();
          } else {
            reject(response);
          }
        }).catch(reject);
      });
    },
    getBindAccount() {
      getAccountBindList().then((response) => {
        if (response.code == this.$ECode.SUCCESS) {
          this.accountList = response.data;
          // 设置登录类型状态
          response.data.forEach(account => {
            if (account.source === "GITEE") this.loginType.gitee = true;
            if (account.source === "GITHUB") this.loginType.github = true;
            if (account.source === "QQ") this.loginType.qq = true;
            if (account.source === "WECHAT") this.loginType.wechat = true;
            if (account.source === "MINI") this.loginType.mini = true;
            if (account.source === "PERSON_WECHAT") this.loginType.personWechat = true;
          });
        }
      });
    },
    handleClick(tab) {
      console.log("点击标签:", tab.name);
    },
    submitForm(formType) {
      if (formType === "editUser") {
        this.$refs.userInfo.validate((valid) => {
          if (!valid) {
            console.log("校验失败");
          } else {
            editUser(this.userInfo).then((response) => {
              if (response.code == this.$ECode.SUCCESS) {
                this.$message({
                  type: "success",
                  message: response.data,
                });
                // 更新store中的用户信息
                this.$store.commit('user/setUserInfo', this.userInfo);
                // 强制从服务器重新获取最新用户信息
                this.authVerifyUser();
              } else {
                this.$message({
                  type: "error",
                  message: response.message,
                });
              }
            }).catch((error) => {
              this.$message({
                type: "error",
                message: "保存失败，请重试",
              });
              console.error("保存用户信息失败:", error);
            });
          }
        });
      } else if (formType === "changePwd") {
        let newPwd = this.userInfo.newPwd;
        let newPwd2 = this.userInfo.newPwd2;
        let oldPwd = this.userInfo.oldPwd;
        if (newPwd != newPwd2) {
          this.$message({
            type: "error",
            message: "两次密码不一致",
          });
          return;
        }
        if (newPwd == oldPwd) {
          this.$message({
            type: "error",
            message: "新旧密码相同",
          });
          return;
        }
        let params = new URLSearchParams();
        params.append("oldPwd", oldPwd);
        params.append("newPwd", newPwd);
        updateUserPwd(params).then((response) => {
          if (response.code == this.$ECode.SUCCESS) {
            this.$message({
              type: "success",
              message: response.data,
            });
            // 清空密码字段
            this.userInfo.oldPwd = "";
            this.userInfo.newPwd = "";
            this.userInfo.newPwd2 = "";
          } else {
            this.$message({
              type: "error",
              message: response.message,
            });
          }
          // 重置表单
          this.$refs.userInfoForm.resetFields();
        }).catch((error) => {
          this.$message({
            type: "error",
            message: "密码修改失败，请重试",
          });
          console.error("密码修改失败:", error);
        });
      }
    },
    validatePwd2(rule, value, callback) {
      if (value !== this.userInfo.newPwd) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    },
    checkPhoto() {
      this.imagecropperShow = true;
      this.imagecropperKey = Math.random();
    },
    deletePhoto(type) {
      if (type === "user") {
        this.userInfo.photoUrl = "";
      } else if (type === "withdraw") {
        this.withdrawForm.photoUrl = "";
        this.withdrawForm.fileUid = "";
      }
      this.icon = false;
    },
    close() {
      this.imagecropperShow = false;
    },
    cropSuccess(data) {
      console.log("头像上传成功:", data);
      this.userInfo.photoUrl = data.data;
      this.userInfo.avatar = data.uid;
      this.imagecropperShow = false;
      
      // 直接调用API保存用户信息
      editUser(this.userInfo).then((response) => {
        if (response.code == this.$ECode.SUCCESS) {
          this.$message({
            type: "success",
            message: "头像更新成功",
          });
          // 更新store
          this.$store.commit('user/setUserInfo', this.userInfo);
          // 强制从服务器获取最新信息
          this.authVerifyUser();
        } else {
          this.$message({
            type: "error",
            message: response.message || "头像更新失败",
          });
        }
      }).catch((error) => {
        this.$message({
          type: "error",
          message: "头像更新失败，请重试",
        });
        console.error("头像更新失败:", error);
      });
    },
    withdrawAmount() {
      this.drawDialogVisible = true;
    },
    submitWithdraw() {
      this.$refs.withdrawForm.validate((valid) => {
        if (valid) {
          let params = new URLSearchParams();
          params.append("account", this.withdrawForm.account);
          params.append("amount", this.withdrawForm.amount * 100); // 转换为分
          params.append("fileUid", this.withdrawForm.fileUid);
          
          addWithdraw(params).then((response) => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: "success",
                message: response.data,
              });
              this.drawDialogVisible = false;
              // 重置提现表单
              this.withdrawForm = {
                account: "",
                photoUrl: "",
                fileUid: "",
                amount: 0
              };
              // 重新获取用户余额
              this.getUserAmount();
              // 重新获取最新用户信息
              this.authVerifyUser();
            } else {
              this.$message({
                type: "error",
                message: response.message,
              });
            }
          }).catch((error) => {
            this.$message({
              type: "error",
              message: "提现申请失败，请重试",
            });
            console.error("提现申请失败:", error);
          });
        }
      });
    },
    goBind(type) {
      // 绑定第三方账号逻辑
      console.log("绑定账号:", type);
    },
    fenToYuan(fen) {
      return (fen / 100).toFixed(2);
    },
    fenToYuanNumber(fen) {
      return fen / 100;
    }
  }
};
</script>

<style scoped>
.my-info-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.my-info-header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.my-info-header h2 {
  color: #303133;
  font-size: 24px;
  margin-bottom: 10px;
}

.my-info-header p {
  color: #909399;
  font-size: 14px;
}

.imgBody {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.imgBody img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.imgBody .inputClass {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #f56c6c;
  font-size: 16px;
  cursor: pointer;
}

.uploadImgBody {
  display: inline-block;
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #fafafa;
}

.uploadImgBody:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.el-form-item {
  margin-bottom: 22px;
}

.el-tabs__content {
  padding: 20px;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style> 


// WEBPACK FOOTER //
// src/components/UserInfo/MyInfo.vue